<div class="container-fluid ac-poppins mt-4">
  <div class="row d-flex justify-content-end">
    <div class="col-3 col-md-4 col-sm-3">
      <div class="search-container">
        <input
          type="text"
          class="search-box"
          [ngClass]="{
            disable: (getBANSearch | keyvalue | json).length == 2 && !searchInput
          }"
          placeholder="Search..."
          [(ngModel)]="searchInput"
          (input)="onSearchChange()"
          tabindex="0"
          #searchInputRef
        />
        <span *ngIf="!searchInput" class="search-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="20"
            height="20"
            viewBox="0 0 50 50"
          >
            <path
              d="M 21 3 C 11.601563 3 4 10.601563 4 20 C 4 29.398438 11.601563 37 21 37 C 24.355469 37 27.460938 36.015625 30.09375 34.34375 L 42.375 46.625 L 46.625 42.375 L 34.5 30.28125 C 36.679688 27.421875 38 23.878906 38 20 C 38 10.601563 30.398438 3 21 3 Z M 21 7 C 28.199219 7 34 12.800781 34 20 C 34 27.199219 28.199219 33 21 33 C 13.800781 33 8 27.199219 8 20 C 8 12.800781 13.800781 7 21 7 Z"
            ></path>
          </svg>
        </span>
        <button
          *ngIf="searchInput"
          class="clear-btn"
          (click)="clearSearchInput()"
          aria-label="Clear search input"
          [ngClass]="{
            disable:
              (getBANSearch | keyvalue | json).length == 2 && !searchInput
          }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="20"
            height="20"
            viewBox="0 0 50 50"
          >
            <path
              d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="table-responsive fs-14">
      <table
        class="table mb-4 dataTable table-striped-custom table-bordered-custom"
        id="example5"
      >
        <thead class="ac-btb">
          <tr>
            <th scope="col">Billing Account Number</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody class="ac-rowhov">
          <ng-container *ngIf="isPaperlessStatus">
            <tr *ngFor="let bans of getBANs | keyvalue; index as i">
              <td>{{ bans.key }}</td>
              <td>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckChecked"
                    [checked]="
                      getDataByBan(bans.key)[0]?.paperlessIndicator === 'ZY'
                    "
                    (change)="
                      updateStatus(
                        bans.key,
                        getDataByBan(bans.key)[0]?.paperlessIndicator
                      )
                    "
                  />
                </div>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="showLoader">
            <td colspan="12" class="text-center mt-2 p-2">
              <article>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="shimmer"></div>
              </article>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      *ngIf="!isLoadMore"
      class="col-12 ac-ff-inter fs-12 font-weight-lighter mt-4 rowp-f d-flex justify-content-center"
    >
      <button
        *ngIf="isPaperlessStatus"
        class="btn ac-btn-primary mb-sm-0 mb-2 w-50"
        (click)="loadMoreBans()"
        style="font-size: 18px"
      >
        Load More...
      </button>
    </div>
    <!-- <div class="col-12 ac-ff-inter fs-12 font-weight-lighter mt-4 rowp-f">
            <p>*It may take up to 24 hours for this page to reflect a recent payment.</p>
        </div> -->
  </div>
</div>
<div class="popup-container" *ngIf="showErrPopup">
  <div class="popup">
    <svg class="info-icon" xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 25 25" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="11"></line>
      <line x1="12" y1="8" x2="12" y2="8" />
    </svg>
    <div class="instruction-div">
      <p class="instruction-text">
        {{ errorMessage }}
      </p>
    </div>
    <div>
      <button type="button" class="okay-button btn btn-primary ac-btn-primary" (click)="closePopup()">
        Okay
      </button>
    </div>
  </div>
</div>